var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEasy = function SvgEasy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E5EFF4",
    width: 110,
    height: 110,
    rx: 3.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.884 90.217-9.242-15.21a4.709 4.709 0 0 1-.66-2.935l.962-9.2c.596-5.697-3.54-10.798-9.238-11.393-.15-.016-.3-.028-.452-.038l-11.04-.667-2.754-20.6a4.052 4.052 0 0 0-4.016-3.514 3.546 3.546 0 0 0-3.546 3.545v30.712a1.57 1.57 0 0 1-1.952 1.522l-9.29-2.33a2.066 2.066 0 0 0-2.026 3.399l4.517 4.937c.08.088.157.18.23.273l4.87 6.21a25.898 25.898 0 0 0 8.96 7.264l16.336 8.025",
    stroke: "#0171B7",
    strokeWidth: 3.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.294 33.886h-9.162a3.14 3.14 0 0 1-3.14-3.14v-7.864a3.14 3.14 0 0 1 3.14-3.14H66.84a3.14 3.14 0 0 1 3.14 3.14v7.864a3.14 3.14 0 0 1-3.14 3.14H55.311",
    stroke: "#FAA61A",
    strokeWidth: 2.354
  }))));
};
export default SvgEasy;